import { getPaginated } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { OpportunityCustomer, OpportunityLead, featureKeys, featurePath } from '.';

const THIRTY_SECONDS = 1000 * 30;
const FIFTEEN_MINUTES = 1000 * 60 * 15;

export const useOpenLeads = (page: number) =>
  useQuery({
    queryKey: featureKeys.opportunities('open-leads', page),
    queryFn: () =>
      getPaginated<OpportunityLead>(`${featurePath}/opportunities/open-leads`, { page }),
    // New leads must surface fast; realtime invalidation supplements this.
    refetchInterval: THIRTY_SECONDS,
    refetchOnWindowFocus: true,
    throwOnError: false,
  });

export const usePastCustomers = (page: number) =>
  useQuery({
    queryKey: featureKeys.opportunities('past-customers', page),
    queryFn: () =>
      getPaginated<OpportunityCustomer>(`${featurePath}/opportunities/past-customers`, { page }),
    refetchInterval: FIFTEEN_MINUTES,
    throwOnError: false,
  });

export const useProspects = (page: number) =>
  useQuery({
    queryKey: featureKeys.opportunities('prospects', page),
    queryFn: () =>
      getPaginated<OpportunityCustomer>(`${featurePath}/opportunities/prospects`, { page }),
    refetchInterval: FIFTEEN_MINUTES,
    throwOnError: false,
  });
